import { TRegions, IRegionFee } from './types';

export const RegionFeeHokkaido: IRegionFee = {
  name: '北海道',
  nameEnglish: 'Hokkaido',
  premiumShipping: 1770,
}

export const RegionFeeNorthTohoku: IRegionFee = {
  name: '北東北',
  nameEnglish: 'North Tohoku',
  premiumShipping: 1150,
}

export const RegionFeeSouthTohoku: IRegionFee = {
  name: '南東北',
  nameEnglish: 'South Tohoku',
  premiumShipping: 1030,
}

export const RegionFeeKanto: IRegionFee = {
  name: '関東',
  nameEnglish: 'Kanto',
  premiumShipping: 880,
}

export const RegionFeeShinetsu: IRegionFee = {
  name: '信越',
  nameEnglish: 'Shinetsu',
  premiumShipping: 870,
}

export const RegionFeeHokuriku: IRegionFee = {
  name: '北陸',
  nameEnglish: 'Hokuriku',
  premiumShipping: 870,
}

export const RegionFeeChubu: IRegionFee = {
  name: '中部',
  nameEnglish: 'Chubu',
  premiumShipping: 870,
}

export const RegionFeeKansai: IRegionFee = {
  name: '関西',
  nameEnglish: 'Kansai',
  premiumShipping: 770,
}

export const RegionFeeChugoku: IRegionFee = {
  name: '中国',
  nameEnglish: 'Chugoku',
  premiumShipping: 780,
}

export const RegionFeeShikoku: IRegionFee = {
  name: '四国',
  nameEnglish: 'Shikoku',
  premiumShipping: 870,
}

export const RegionFeeKyushu: IRegionFee = {
  name: '九州',
  nameEnglish: 'Kyushu',
  premiumShipping: 910,
}

export const RegionFeeOkinawa: IRegionFee = {
  name: '沖縄',
  nameEnglish: 'Okinawa',
  premiumShipping: 1630,
}

const Regions: TRegions = [
  {
    name: '北海道',
    nameEnglish: 'Hokkaido, Japan',
    nameHiragana: 'ほっかいどう',
    latitude: 43.2203266,
    longitude: 142.8634737,
    fee: RegionFeeHokkaido,
  },
  {
    name: '青森県',
    nameEnglish: 'Aomori, Japan',
    nameHiragana: 'あおもり',
    latitude: 40.6770828,
    longitude: 140.8035238,
    fee: RegionFeeNorthTohoku,
  },
  {
    name: '岩手県',
    nameEnglish: 'Iwate, Japan',
    nameHiragana: 'いわて',
    latitude: 39.4709428,
    longitude: 141.2439248,
    fee: RegionFeeNorthTohoku,
  },
  {
    name: '宮城県',
    nameEnglish: 'Miyagi, Japan',
    nameHiragana: 'みやぎ',
    latitude: 38.5983454,
    longitude: 140.7924786,
    fee: RegionFeeSouthTohoku,
  },
  {
    name: '秋田県',
    nameEnglish: 'Akita, Japan',
    nameHiragana: 'あきた',
    latitude: 39.6569071,
    longitude: 140.1343964,
    fee: RegionFeeNorthTohoku,
  },
  {
    name: '山形県',
    nameEnglish: 'Yamagata, Japan',
    nameHiragana: 'やまがた',
    latitude: 38.5830136,
    longitude: 139.8598948,
    fee: RegionFeeSouthTohoku,
  },
  {
    name: '福島県',
    nameEnglish: 'Fukushima, Japan',
    nameHiragana: 'ふくしま',
    latitude: 37.3549375,
    longitude: 139.7385805,
    fee: RegionFeeSouthTohoku,
  },
  {
    name: '茨城県',
    nameEnglish: 'Ibaraki, Japan',
    nameHiragana: 'いばらき',
    latitude: 36.4926887,
    longitude: 140.2843208,
    fee: RegionFeeKanto,
  },
  {
    name: '栃木県',
    nameEnglish: 'Tochigi, Japan',
    nameHiragana: 'とちぎ',
    latitude: 36.3708399,
    longitude: 139.6892469,
    fee: RegionFeeKanto,
  },
  {
    name: '群馬県',
    nameEnglish: 'Gunma, Japan',
    nameHiragana: 'ぐんま',
    latitude: 36.6295526,
    longitude: 138.8717897,
    fee: RegionFeeKanto,
  },
  {
    name: '埼玉県',
    nameEnglish: 'Saitama, Japan',
    nameHiragana: 'さいたま',
    latitude: 36.0254383,
    longitude: 139.1179216,
    fee: RegionFeeKanto,
  },
  {
    name: '千葉県',
    nameEnglish: 'Chiba, Japan',
    nameHiragana: 'ちば',
    latitude: 35.5943471,
    longitude: 140.053104,
    fee: RegionFeeKanto,
  },
  {
    name: '東京都',
    nameEnglish: 'Tokyo, Japan',
    nameHiragana: 'とうきょう',
    latitude: 35.6803997,
    longitude: 139.7690174,
    fee: RegionFeeKanto,
  },
  {
    name: '神奈川県',
    nameEnglish: 'Kanagawa, Japan',
    nameHiragana: 'かながわ',
    latitude: 35.4034749,
    longitude: 139.2558569,
    fee: RegionFeeKanto,
  },
  {
    name: '新潟県',
    nameEnglish: 'Niigata, Japan',
    nameHiragana: 'にいがた',
    latitude: 37.7923826,
    longitude: 138.7891092,
    fee: RegionFeeShinetsu,
  },
  {
    name: '富山県',
    nameEnglish: 'Toyama, Japan',
    nameHiragana: 'とやま',
    latitude: 36.5601084,
    longitude: 137.1722767,
    fee: RegionFeeHokuriku,
  },
  {
    name: '石川県',
    nameEnglish: 'Ishikawa, Japan',
    nameHiragana: 'いしかわ',
    latitude: 36.3942221,
    longitude: 136.4052631,
    fee: RegionFeeHokuriku,
  },
  {
    name: '福井県',
    nameEnglish: 'Fukui, Japan',
    nameHiragana: 'ふくい',
    latitude: 35.8806208,
    longitude: 136.1359465,
    fee: RegionFeeHokuriku,
  },
  {
    name: '山梨県',
    nameEnglish: 'Yamanashi, Japan',
    nameHiragana: 'やまなし',
    latitude: 35.5406755,
    longitude: 138.5611284,
    fee: RegionFeeKanto,
  },
  {
    name: '長野県',
    nameEnglish: 'Nagano, Japan',
    nameHiragana: 'ながの',
    latitude: 36.0941541,
    longitude: 137.9069178,
    fee: RegionFeeShinetsu,
  },
  {
    name: '岐阜県',
    nameEnglish: 'Gifu, Japan',
    nameHiragana: 'ぎふ',
    latitude: 35.7437491,
    longitude: 136.9805103,
    fee: RegionFeeChubu,
  },
  {
    name: '静岡県',
    nameEnglish: 'Shizuoka, Japan',
    nameHiragana: 'しずおか',
    latitude: 35.0929397,
    longitude: 138.3190276,
    fee: RegionFeeChubu,
  },
  {
    name: '愛知県',
    nameEnglish: 'Aichi, Japan',
    nameHiragana: 'あいち',
    latitude: 35.0464602,
    longitude: 137.2642268,
    fee: RegionFeeChubu,
  },
  {
    name: '三重県',
    nameEnglish: 'Mie, Japan',
    nameHiragana: 'みえ',
    latitude: 34.2958037,
    longitude: 136.5428939,
    fee: RegionFeeChubu,
  },
  {
    name: '滋賀県',
    nameEnglish: 'Shiga, Japan',
    nameHiragana: 'しが',
    latitude: 35.1974364,
    longitude: 136.0458707,
    fee: RegionFeeKansai,
  },
  {
    name: '京都府',
    nameEnglish: 'Kyoto, Japan',
    nameHiragana: 'きょうと',
    latitude: 35.2658669,
    longitude: 135.3851986,
    fee: RegionFeeKansai,
  },
  {
    name: '大阪府',
    nameEnglish: 'Osaka, Japan',
    nameHiragana: 'おおさか',
    latitude: 34.6922035,
    longitude: 135.3355033,
    fee: RegionFeeKansai,
  },
  {
    name: '兵庫県',
    nameEnglish: 'Hyogo, Japan',
    nameHiragana: 'ひょうご',
    latitude: 35.0124176,
    longitude: 134.8260963,
    fee: RegionFeeKansai,
  },
  {
    name: '奈良県',
    nameEnglish: 'Nara, Japan',
    nameHiragana: 'なら',
    latitude: 34.2975528,
    longitude: 135.8279734,
    fee: RegionFeeKansai,

  },
  {
    name: '和歌山県',
    nameEnglish: 'Wakayama, Japan',
    nameHiragana: 'わかやま',
    latitude: 33.9480914,
    longitude: 135.3745358,
    fee: RegionFeeKansai,
  },
  {
    name: '鳥取県',
    nameEnglish: 'Tottori, Japan',
    nameHiragana: 'とっとり',
    latitude: 35.3573161,
    longitude: 133.4066618,
    fee: RegionFeeChugoku,
  },
  {
    name: '島根県',
    nameEnglish: 'Shimane, Japan',
    nameHiragana: 'しまね',
    latitude: 35.1244094,
    longitude: 132.6293446,
    fee: RegionFeeChugoku,
  },
  {
    name: '岡山県',
    nameEnglish: 'Okayama, Japan',
    nameHiragana: 'おかやま',
    latitude: 34.8963407,
    longitude: 133.6375314,
    fee: RegionFeeChugoku,
  },
  {
    name: '広島県',
    nameEnglish: 'Hiroshima, Japan',
    nameHiragana: 'ひろしま',
    latitude: 34.8823408,
    longitude: 133.0194897,
    fee: RegionFeeChugoku,
  },
  {
    name: '山口県',
    nameEnglish: 'Yamaguchi, Japan',
    nameHiragana: 'やまぐち',
    latitude: 34.2796769,
    longitude: 131.5212742,
    fee: RegionFeeChugoku,
  },
  {
    name: '徳島県',
    nameEnglish: 'Tokushima, Japan',
    nameHiragana: 'とくしま',
    latitude: 33.9419655,
    longitude: 134.3236557,
    fee: RegionFeeShikoku,
  },
  {
    name: '香川県',
    nameEnglish: 'Kagawa, Japan',
    nameHiragana: 'かがわ',
    latitude: 34.2225915,
    longitude: 134.0199152,
    fee: RegionFeeShikoku,
  },
  {
    name: '愛媛県',
    nameEnglish: 'Ehime, Japan',
    nameHiragana: 'えひめ',
    latitude: 33.6025306,
    longitude: 132.7857583,
    fee: RegionFeeShikoku,
  },
  {
    name: '高知県',
    nameEnglish: 'Kochi, Japan',
    nameHiragana: 'こうち',
    latitude: 33.5481246,
    longitude: 133.2521507,
    fee: RegionFeeShikoku,
  },
  {
    name: '福岡県',
    nameEnglish: 'Fukuoka, Japan',
    nameHiragana: 'ふくおか',
    latitude: 33.568737,
    longitude: 130.4992481,
    fee: RegionFeeKyushu,
  },
  {
    name: '佐賀県',
    nameEnglish: 'Saga, Japan',
    nameHiragana: 'さが',
    latitude: 33.3078371,
    longitude: 130.2271243,
    fee: RegionFeeKyushu,
  },
  {
    name: '長崎県',
    nameEnglish: 'Nagasaki, Japan',
    nameHiragana: 'ながさき',
    latitude: 33.2488525,
    longitude: 129.6930912,
    fee: RegionFeeKyushu,
  },
  {
    name: '熊本県',
    nameEnglish: 'Kumamoto, Japan',
    nameHiragana: 'くまもと',
    latitude: 32.8594427,
    longitude: 130.7969149,
    fee: RegionFeeKyushu,
  },
  {
    name: '大分県',
    nameEnglish: 'Oita, Japan',
    nameHiragana: 'おおいた',
    latitude: 33.1589299,
    longitude: 131.3611121,
    fee: RegionFeeKyushu,
  },
  {
    name: '宮崎県',
    nameEnglish: 'Miyazaki, Japan',
    nameHiragana: 'みやざき',
    latitude: 32.6036022,
    longitude: 131.441251,
    fee: RegionFeeKyushu,
  },
  {
    name: '鹿児島県',
    nameEnglish: 'Kagoshima, Japan',
    nameHiragana: 'かごしま',
    latitude: 31.3911958,
    longitude: 130.8778586,
    fee: RegionFeeKyushu,
  },
  {
    name: '沖縄県',
    nameEnglish: 'Okinawa, Japan',
    nameHiragana: 'おきなわ',
    latitude: 26.1201911,
    longitude: 127.7025012,
    fee: RegionFeeOkinawa,
  },
];

export default Regions;
